module.exports = __webpack_public_path__ + "img/bg2.d91996cc.png";